import { createSlice } from "@reduxjs/toolkit";
import { logger } from "../utils/logger";
const initialState = {
	topicId: "All",
	topicName: "All",
};

const selectedTopicSlice = createSlice({
	name: "selectedTopic",
	initialState,
	reducers: {
		setSelectedTopic: (state, action) => {
			logger.log("Action payoload inside selectedTopicSlice: ", action.payload);
			state.topicId = action.payload.topicId;
			state.topicName = action.payload.topicName;
		},
	},
});

export const { setSelectedTopic } = selectedTopicSlice.actions;
export default selectedTopicSlice.reducer;
